import React from "react";
import styles from "./Digits.module.css";

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function roundToDown(num, precision) {
  const factor = Math.pow(10, precision);
  return Math.floor(num * factor) / factor;
}

function setupNumber(num, incrementRate, interval, isFederal, slideUp) {
  const elements = [];
  const withCommas = numberWithCommas(parseFloat(num).toFixed(2));
  const noCommasLength = num.toString().length;
  let debtRounded = roundToDown(
    num,
    -(Math.floor(num).toString().length - 1)
  );
  if (debtRounded.toString().charAt(0) !== "1") {
    debtRounded = `${1}${debtRounded.toString().substring(1)}`;
  }
  const digitsAnimatedThroughInOneAnimationCycle = 10;

  let animationDuration =
    (Number(debtRounded) / Math.abs(incrementRate)) *
    digitsAnimatedThroughInOneAnimationCycle *
    (interval / 1000);

  const numbersInBetweenMap = {
    0: "1 2 3 4 5 6 7 8 9",
    1: "2 3 4 5 6 7 8 9 0",
    2: "3 4 5 6 7 8 9 0 1",
    3: "4 5 6 7 8 9 0 1 2",
    4: "5 6 7 8 9 0 1 2 3",
    5: "6 7 8 9 0 1 2 3 4",
    6: "7 8 9 0 1 2 3 4 5",
    7: "8 9 0 1 2 3 4 5 6",
    8: "9 0 1 2 3 4 5 6 7",
    9: "0 1 2 3 4 5 6 7 8",
  };
  elements.push(
    <div key="dollar-sign" className={styles["dollar-sign-container"]}>
      <div className={styles["dollar-sign"]}>$</div>
    </div>
  );
  let digitPlace = 0;
  for (let i = 0; i < withCommas.length; i += 1) {
    let newElementToAdd;
    const key = `digit-${i}`; // Generate a unique key based on the index
    if (Number.isNaN(Number.parseInt(withCommas.charAt(i), 10))) {
      newElementToAdd = (
        <span key={key} className={styles["non-digit"]}>
          {withCommas.charAt(i)}
        </span>
      );
    } else {
      let clssName;
      if (slideUp) {
        if (
          digitPlace < noCommasLength - incrementRate.toString().length ||
          !isFederal
        ) {
          clssName = styles["digit-container-animation-pause"];
        } else {
          clssName = styles["digit-container"];
        }
      }
      if (!slideUp) {
        if (
          digitPlace < noCommasLength - incrementRate.toString().length ||
          !isFederal
        ) {
          clssName = styles["digit-container-animation-pause-slide-down"];
        } else {
          clssName = styles["digit-container-slide-down"];
        }
      }
      newElementToAdd = (
        <div key={key} className={styles["digit"]}>
          <div
            className={clssName}
            style={{
              animationDuration: `${animationDuration}s`,
            }}
          >
            {withCommas.charAt(i)} {numbersInBetweenMap[withCommas.charAt(i)]}{" "}
            {withCommas.charAt(i)}
          </div>
        </div>
      );
      digitPlace += 1;
      if (animationDuration < 7) {
        animationDuration /= 1.4;
      } else {
        animationDuration /= 10;
      }
    }
    elements.push(newElementToAdd);
  }
  return elements;
}

function DebtClockDigits({
  initialDebt,
  incrementRate,
  interval,
  isFederal,
  slideUp,
}) {
  const startDebt = setupNumber(
    initialDebt,
    incrementRate,
    interval,
    isFederal,
    slideUp
  );
  return <div className={styles["clock-text"]}>{startDebt}</div>;
}

export default DebtClockDigits;
